module.exports = {"TXTWCL_Browse_tournaments":{"id":"TXTWCL_Browse_tournaments","defaultMessage":"Søg efter turneringer","track":"Browse tournaments"}}